import { render, staticRenderFns } from "./ItemClassCategory.vue?vue&type=template&id=00975944"
import script from "./ItemClassCategory.vue?vue&type=script&lang=js"
export * from "./ItemClassCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports